export const SENTRY_DSN =
  'https://53ff996300e94e7983242fc53bc63c5f@sentry.io/1360936';
